let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("elmfm")).then(() => parcelRequire('44Pd8'));